export default [
  {
    label: 'Unknown', value: 'Unknown',
  },
  {
    label: '1-49', value: '1-49',
  },
  {
    label: '50-99', value: '50-99',
  },
  {
    label: '100-199', value: '100-199',
  },
  {
    label: '200-999', value: '200-999',
  },
  {
    label: '1,000-5,000', value: '1,000-5,000',
  },
  {
    label: '5,001-10,000', value: '5,001-10,000',
  },
  {
    label: '10,001-25,000', value: '10,001-25,000',
  },
  {
    label: '25,001-50,000', value: '25,001-50,000',
  },
  {
    label: '50,001-100,000', value: '50,001-100,000',
  },
  {
    label: 'More than 100,000', value: 'More than 100,000',
  },
];



// WEBPACK FOOTER //
// ./src/data/noOfCreditors.js